import { useAddSourceCustom } from "@/api/knowledge-source/add-source-custom";
import { useAddSourceFile } from "@/api/knowledge-source/add-source-file";
import KnowledgeSourceButtons from "@/components/ai-training/knowledge-source-buttons/knowledge-source-buttons";
import { Card } from "@/components/ui/card";
import FileDrop from "@/components/ui/file-drop";
import { Progress } from "@/components/ui/progress";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import useGlobalPermission from "@/store/user-permissions";
import { useEffect, useState } from "react";

const ShoeSizeRefine = () => {
    const [file, setFile] = useState<File | null>(null);

    const { mutate: addPDF, isPending, progress, isSuccess } = useAddSourceFile();

    useEffect(() => {
        if (isSuccess && !isPending) {
            setFile(null);
        }
    }, [isSuccess, isPending]);

    const handleAddSource = () => {
        const formData = new FormData();
        if (file) {
            formData.append("file", file);
        }
        addPDF({ file: file });
    };

    //custom text source
    const [header, setHeader] = useState("");
    const [desc, setDesc] = useState("");

    const { mutate: addSource, isPending: customAddPending, isSuccess: customAddSuccess } = useAddSourceCustom();

    const handleAddCustomSource = () => {
        addSource({ header, desc });
    };

    useEffect(() => {
        if (!customAddPending && customAddSuccess) {
            setDesc("");
            setHeader("");
        }
    }, [customAddSuccess, customAddPending]);
    const { permissionList } = useGlobalPermission();
    const trainingPermission = permissionList.find((item) => item.module.name === "AI_Training");
    return (
        <div>
            <Card className="bg-white p-4 ">
                <FileDrop fileType="PDF&DOC" fileSetter={setFile} file={file} />
                {file && <Progress className="mt-4" value={progress} />}
                <Separator className="my-4" />
                <div className="text-sm text-gray-500">
                    <p>Upload a document to refine the AI model. The document should contain information about shoe sizes and conversions.</p>
                    <p className="mt-2">Supported file types: DOC, DOCX, PDF. Maximum file size: 10MB.</p>
                    <p className="mt-2">
                        Please ensure that the document is well-formatted and contains clear information about shoe sizes. The AI model will use this
                        information to improve its understanding of shoe sizes and conversions.
                    </p>
                    <p className="mt-2">If you have any questions or need assistance, please contact our support team.</p>
                    <p className="mt-2">Thank you for helping us improve our AI model!</p>
                </div>
                <div className="mt-4 border-t p-4">
                    <KnowledgeSourceButtons onSubmit={handleAddSource} loading={isPending} disabled={!file} />
                </div>
            </Card>
            <div className="flex items-center justify-center mt-4 w-full overflow-hidden gap-3">
                <Separator className="my-4" />
                <h3>Or</h3>
                <Separator className="my-4" />
            </div>
            <Card className="bg-white p-4 mt-4">
                <div>
                    {/* <h3 className="mb-2 font-bold">Name</h3> */}
                    {/* <Input
                        className="mb-3 py-6"
                        placeholder="Enter the Name of Your Data Source"
                        onChange={(e) => setHeader(e.target.value)}
                        value={header}
                        disabled={!trainingPermission?.can_create}
                    /> */}
                    <h3 className="mb-2 font-bold">Shoe Size Content</h3>
                    <Textarea
                        disabled={!trainingPermission?.can_create}
                        className="mb-3 py-6"
                        onChange={(e) => setDesc(e.target.value)}
                        value={desc}
                        placeholder="This text will be added to the knowledge of your Chatbot. Carefully add relevant content."
                    />

                    <KnowledgeSourceButtons onSubmit={handleAddCustomSource} loading={customAddPending} />
                </div>
            </Card>
        </div>
    );
};

export default ShoeSizeRefine;
